import Flux from '../../flux/Flux.js';
import FloatingNotification from './FloatingNotification.js';
import { Component } from 'react';

let renderedNotifications = [];

class FloatingNotifications extends Component {
	constructor(props) {
		super(props);

		this.state = {
			notifications: [],
			fakeNotifications: [],
		};

		this.onStoreChange = this.onStoreChange.bind(this);
	}

	componentDidMount() {
		Flux.Notification.addFloatingNotificationsChangeListener(this.onStoreChange);
		Flux.Notification.addFakeFloatingNotificationsChangeListener(this.onFakeNotificationAdded.bind(this));
	}

	componentWillUnmount() {
		Flux.Notification.removeFloatingNotificationsChangeListener(this.onStoreChange);
		Flux.Notification.removeFakeFloatingNotificationsChangeListener(this.onFakeNotificationAdded.bind(this));
	}

	onFakeNotificationAdded(subject, text, icon) {
		this.setState({
			fakeNotifications: [
				...this.state.fakeNotifications,
				{
					id: Math.floor(Math.random() * (999999999999999 - 0) + 0) * -1, // random number for id because fake
					subject: subject,
					text: text,
					unread: true,
					unseen: true,
					target: [],
					floating: true,
					iconUrl: icon,
				},
			],
		});
	}

	onStoreChange() {
		this.setState({
			notifications: Flux.Notification.getFloatingNotifications(),
		});
	}

	getNotifications() {
		renderedNotifications = [];

		this.state.fakeNotifications.forEach((notification) => {
			renderedNotifications.push(
				<FloatingNotification
					key={notification.id}
					notification={notification}
					onHideFunc={() => {
						this.setState({
							fakeNotifications: this.state.fakeNotifications.filter((n) => n.id !== notification.id),
						});
					}}
					autoHide={true}
					autoHideTime={10000}
				/>,
			);
		});

		const sortedNotifications = [...this.state.notifications].sort((a, b) => a.id - b.id);

		sortedNotifications.forEach((notification) => {
			renderedNotifications.push(
				<FloatingNotification
					key={notification.id}
					notification={notification}
					onHideFunc={() => {
						Flux.Notification.markFloatingNotificationAsRead(notification.id);
					}}
					autoHide={true}
					autoHideTime={10000}
				/>,
			);
		});

		return renderedNotifications;
	}

	render() {
		const secondNavbarElem = document.querySelector('.vxsecondnavbar__fixed');
		const additionalClasses = secondNavbarElem ? 'floating-notifications-secondnavbar' : '';
		renderedNotifications = this.getNotifications();
		return <div className={'floating-notifications-container ' + additionalClasses}>{renderedNotifications}</div>;
	}
}

export default FloatingNotifications;
